import { useRef } from 'react';
import { isEmpty } from 'lodash';
import { ChevronRight } from 'lucide-react';
import { useAppSelector } from 'hooks/useAppSelector';
import { RootState } from 'app/store';
import SettingsLayout from 'modules/settings/layouts/SettingsLayout/SettingsLayout';
import MainButton from 'modules/auth/components/MainButton';
import { Text } from 'components/text/primary/Text';

import OverlayLoader from 'components/loader/OverlayLoader';
import Availability from 'modules/profile/components/availability/Availability';
import { useUpdateUserMutation } from 'modules/auth/services/user.mutation.service';
import { useAuth } from 'modules/auth/context/AuthContextV2';
import Button from 'components/v2/button/Button';

const EditAvailability = () => {
  const availabilityRef = useRef<any>(null);
  const { user, loading } = useAuth();
  const [updateUser, { data }] = useUpdateUserMutation();

  const handleSubmit = () => {
    if (availabilityRef?.current) {
      availabilityRef?.current();
    }
  };

  return (
    <SettingsLayout>
      <main className="flex-grow mb-4">
        <div className="w-full my-8 mb-6">
          {isEmpty(data ?? user) ? (
            <OverlayLoader />
          ) : (
            <Availability
              ref={availabilityRef}
              update={updateUser}
              data={data ?? user ?? undefined}
              setPrevOrSkip={() => {}}
              title="Edit your social availability"
            />
          )}
        </div>
      </main>
      <footer className="mb-4">
        <Button
          variant="primary"
          className="w-full py-4 flex items-center justify-between"
          onClick={handleSubmit}
          disabled={loading}
        >
          <div className="w-full flex items-center justify-between px-5">
            <Text size="small">{loading ? 'Saving...' : 'Save Changes'}</Text>
            {loading ? null : <ChevronRight color="#fff" />}
          </div>
        </Button>
      </footer>
    </SettingsLayout>
  );
};

export default EditAvailability;
